import './MazeModule.css';
import MazeImg from './img/maze.png';

function MazeModule() {
  return (
      <div>
          <h3>Maze</h3>
          <img src={MazeImg} width="100%" alt="" />
      </div>
  );
}

export default MazeModule;
